import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { toggleJiraTicketModal } from '../../../redux/actions/jiraActions';
import '../main.css';
export const allTicketsDriverObj = (dispatch) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.createTicket',
        popover: {
          title: 'Create New Ticket',
          description: `Use the "Create Ticket" feature to document, assign, and track tasks or issues.
           This helps ensure that all tasks are properly managed and completed.`,
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.filterTickets',
        popover: {
          title: 'Filter Tickets',
          description:
            'Filter tickets based on criteria such as assignee, status, or priority to find relevant tasks quickly.',
          side: 'top',
          align: 'end',
        },
      },
      {
        element: '.myTickets',
        popover: {
          title: 'My Tickets',
          description:
            'View tickets assigned to you. This tab helps you focus on the tasks that require your attention.',
          side: 'top',
          align: 'end',
        },
      },
      {
        element: '.openTickets',
        popover: {
          title: 'Open Tickets',
          description:
            'This tab displays all open tickets, allowing you to track ongoing tasks that have not yet been completed.',
          side: 'top',
          align: 'end',
        },
      },
      {
        element: '.closeTickets',
        popover: {
          title: 'Closed Tickets',
          description:
            'View all tickets that have been completed and closed. This helps keep track of resolved issues.',
          side: 'top',
          align: 'end',
        },
      },
      {
        element: '.overDueTickets',
        popover: {
          title: 'Overdue Tickets',
          description: `The Overdue Tickets tab displays tickets that are past their due date,
           helping you prioritize tasks that need immediate attention.`,
          side: 'top',
          align: 'end',
        },
      },
      {
        element: '.ticketTable',
        popover: {
          title: 'Ticket Table Overview',
          description: `This table provides all the information you need about the tickets,
           including their status, assignee, and deadlines.`,
          side: 'left',
          align: 'start',
          onNextClick: () => {
            dispatch(toggleJiraTicketModal());
            driverObj.destroy();
          },
        },
      },
    ],
  });
  return driverObj;
};
export default allTicketsDriverObj;
